import { defineComponent as m, createElementBlock as i, openBlock as a, mergeProps as l, unref as e, renderSlot as p, createElementVNode as c } from "vue";
import o from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Brand/brand.js";
import { cssVarsFromBreakpointProps as n } from "../breakpoints.js";
import { c_brand_Height as f } from "../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_brand_Height.js";
import { c_brand_Width as u } from "../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_brand_Width.js";
import { useOUIAProps as g } from "../helpers/ouia.js";
const w = ["src", "alt"], y = ["src", "alt"], I = /* @__PURE__ */ m({
  name: "PfBrand",
  inheritAttrs: !1,
  __name: "Brand",
  props: {
    src: {},
    alt: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    width: {},
    widthSm: {},
    widthMd: {},
    widthLg: {},
    widthXl: {},
    width2xl: {},
    height: {},
    heightSm: {},
    heightMd: {},
    heightLg: {},
    heightXl: {},
    height2xl: {}
  },
  setup(d) {
    const r = d, s = g({ id: r.ouiaId, safe: r.ouiaSafe }), h = {
      ...n(r, "width", u.name),
      ...n(r, "height", f.name)
    };
    return (t, B) => t.$slots.default ? (a(), i("picture", l({ key: 0 }, { ...e(s), ...t.$attrs }, {
      class: [e(o).brand, e(o).modifiers.picture],
      style: h
    }), [
      p(t.$slots, "default"),
      c("img", {
        src: t.src,
        alt: t.alt
      }, null, 8, w)
    ], 16)) : (a(), i("img", l({ key: 1 }, { ...e(s), ...t.$attrs }, {
      class: e(o).brand,
      src: t.src,
      alt: t.alt
    }), null, 16, y));
  }
});
export {
  I as default
};
